import React from 'react';
import { TrashIcon } from '@heroicons/react/24/outline';

const DangerZone = ({ onShowDeleteModal }) => {
    return (
        <section className="bg-rose-50 dark:bg-rose-500/5 border-rose-200 dark:border-rose-500/20 rounded-3xl p-8 border shadow-xl transition-all">
            <h3 className="text-lg font-semibold text-rose-500 mb-2">
                Danger Zone
            </h3>
            <p className="text-slate-500 dark:text-slate-400 text-sm mb-6">
                Once you delete your account, there is no going back. All your local data and linked Jira accounts will be permanently removed.
            </p>
            <button
                onClick={onShowDeleteModal}
                className="text-rose-500 bg-rose-500/10 hover:bg-rose-500 hover:text-white border border-rose-500/20 px-6 py-2.5 rounded-xl font-semibold flex items-center gap-2 transition-all active:scale-95"
            >
                <TrashIcon className="size-5" />
                Delete My Account
            </button>
        </section>
    );
};

export default DangerZone;
